// import ApiServices from "../../../../../Utils/ApiServices/ApiServices";

// const authHeaders = (token) => ({
//   Authorization: `Bearer ${token}`,
//   "Content-Type": "application/json",
// });

// export const menuApi = {
//   getTree: ({ token, clientId, locationId }) =>
//     ApiServices.get(`/api/v1/menu/${clientId}/locations/${locationId}/tree/`, authHeaders(token)),

//   replicateMenu: ({ token, clientId, locationId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/replicate/`,
//       payload,
//       authHeaders(token)
//     ),

//   createFoodType: ({ token, clientId, locationId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateFoodType: ({ token, clientId, locationId, foodTypeId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteFoodType: ({ token, clientId, locationId, foodTypeId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/`,
//       authHeaders(token)
//     ),

//   createCategory: ({ token, clientId, locationId, foodTypeId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateCategory: ({ token, clientId, locationId, foodTypeId, categoryId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteCategory: ({ token, clientId, locationId, foodTypeId, categoryId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/`,
//       authHeaders(token)
//     ),

//   createItem: ({ token, clientId, locationId, foodTypeId, categoryId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateItem: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteItem: ({ token, clientId, locationId, foodTypeId, categoryId, itemId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/`,
//       authHeaders(token)
//     ),

//   createVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/`,
//       authHeaders(token)
//     ),

//   createVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, variantId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/${variantId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, variantId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/${variantId}/`,
//       authHeaders(token)
//     ),

//   createDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
//     ApiServices.post(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/`,
//       payload,
//       authHeaders(token)
//     ),

//   updateDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantId, payload }) =>
//     ApiServices.patch(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/${variantId}/`,
//       payload,
//       authHeaders(token)
//     ),

//   deleteDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantId }) =>
//     ApiServices.delete(
//       `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/${variantId}/`,
//       authHeaders(token)
//     ),
// };

import ApiServices from "../../../../../Utils/ApiServices/ApiServices";

const jsonHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

const formDataHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "multipart/form-data",
});

export const menuApi = {
  getTree: ({ token, clientId, locationId }) =>
    ApiServices.get(
      `/api/v1/menu/${clientId}/locations/${locationId}/tree/`,
      jsonHeaders(token)
    ),

  replicateMenu: ({ token, clientId, locationId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/replicate/`,
      payload,
      jsonHeaders(token)
    ),

  createFoodType: ({ token, clientId, locationId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  updateFoodType: ({ token, clientId, locationId, foodTypeId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  deleteFoodType: ({ token, clientId, locationId, foodTypeId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/`,
      jsonHeaders(token)
    ),

  createCategory: ({ token, clientId, locationId, foodTypeId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  updateCategory: ({ token, clientId, locationId, foodTypeId, categoryId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  deleteCategory: ({ token, clientId, locationId, foodTypeId, categoryId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/`,
      jsonHeaders(token)
    ),

  createItem: ({ token, clientId, locationId, foodTypeId, categoryId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  updateItem: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/`,
      payload,
      payload instanceof FormData ? formDataHeaders(token) : jsonHeaders(token)
    ),

  deleteItem: ({ token, clientId, locationId, foodTypeId, categoryId, itemId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/`,
      jsonHeaders(token)
    ),

  createVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/`,
      payload,
      jsonHeaders(token)
    ),

  updateVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/`,
      payload,
      jsonHeaders(token)
    ),

  deleteVariantGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/`,
      jsonHeaders(token)
    ),

  createVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/`,
      payload,
      jsonHeaders(token)
    ),

  updateVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, variantId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/${variantId}/`,
      payload,
      jsonHeaders(token)
    ),

  deleteVariantInGroup: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantGroupId, variantId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variant-groups/${variantGroupId}/variants/${variantId}/`,
      jsonHeaders(token)
    ),

  createDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, payload }) =>
    ApiServices.post(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/`,
      payload,
      jsonHeaders(token)
    ),

  updateDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantId, payload }) =>
    ApiServices.patch(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/${variantId}/`,
      payload,
      jsonHeaders(token)
    ),

  deleteDirectVariant: ({ token, clientId, locationId, foodTypeId, categoryId, itemId, variantId }) =>
    ApiServices.delete(
      `/api/v1/menu/${clientId}/locations/${locationId}/food-types/${foodTypeId}/categories/${categoryId}/items/${itemId}/variants/${variantId}/`,
      jsonHeaders(token)
    ),
};